<script lang="ts">
  export let backgroundColor = 'bg-ondark-low';
  export let rounded = 'rounded-lg';
  export let border = '';
  export let readonly = false;
</script>

<article class="flex flex-col p-4 {rounded} {backgroundColor} {border}">
  <div class="flex {readonly ? 'items-center' : 'flex-col md:flex-row md:items-center'}">
    <div class="flex items-center overflow-hidden {!readonly ? 'mb-4 md:mb-0' : ''}">
      <slot name="icon" />

      <div class="ml-4 flex w-full min-w-0 flex-col md:w-auto">
        <slot name="title" />
        <slot name="subtitle" />
      </div>
    </div>

    <slot />
  </div>

  <slot name="footer" />
</article>
